{
  "common": {
    "btnText": {
      "confirm": "確定",
      "back": "返回主頁"
    },
    "loading": "加載中 ..."
  },
  "header": {
    "logo": "/asset/images/common/logo_alive.png"
  },
  "footer": {
    "tNC": "條款及細則",
    "pp": "私隱政策聲明",
    "tut": "用戶指南"
  },
  "landing": {
    "landingText1": "歡迎你，",
    "landingText2": "Life Artisan!",
    "landingText3": "在嶄新的一天裏活出平衡人生吧",
    "btnText": "立即探索"
  },
  "home": {
    "profileText1": "與你活出最好的人生",
    "profileText2": "",
    "emotion": {
      "vital_scan_remark": "按你今天心情給你的小提醒",
      "question": "你今天心情如何？",
      "options": {
        "excited": {
          "text": "快樂",
          "content": [
            {
              "msg": "決定以「快樂」來應對生活，是很勇敢的選擇。",
              "tip": "原來多走動是提神的好方法！想感覺更好？即刻去拿杯水或者快步走吧！"
            },
            {
              "msg": "幸福不會從天而降，而是取決於你的行動。",
              "tip": "到了晚上或週末，挑個時段關掉手機，讓自己全心投入在重要的人和事情上。"
            },
            {
              "msg": "喜悅因分享加倍，憂傷因分擔而減半。",
              "tip": "向他人表達感謝有助提高工作效率及建立團隊精神。不如現在抽出 5 分鐘時間，在感謝牆裏向他人表達感謝吧！"
            }
          ]
        },
        "calm": {
          "text": "平靜",
          "content": [
            {
              "msg": "平靜的頭腦是應對挑戰的終極武器，所以放鬆就好。 ",
              "tip": "感到平靜嗎？太好了！你現在擁有極高的專注力。聽一些古典音樂、爵士樂和自然界的聲音，可以進一步提高你的工作效率。"
            },
            {
              "msg": "當你專注於好的一面，更好的就會出現。",
              "tip": "積極思考會引領你的思想和感受朝向更樂觀的方向發展。持續寫感恩日記並列出你所感謝的事物，能讓你更著眼於生活上的好事！"
            },
            {
              "msg": "生命的價值不在於發現自我，而是創造自我。",
              "tip": "練習做些隨意的善舉，也要練習善待自己。善待他人能讓你感受到一種使命感，而善待自己可令你繼續對他人產生積極的影響  ;)"
            }
          ]
        },
        "stress": {
          "text": "有壓力",
          "content": [
            {
              "msg": "我們無法控制身上發生的每一件事，但我們可以控制自己的反應。",
              "tip": "呼吸是一種減壓的有力工具，而且只需要短短幾分鐘。參與我們的呼吸紓壓練習，您的感受將會有所不同！"
            },
            {
              "msg": "生活的壓力和煩惱就像一杯水，你拿著它一分鐘，當然不成問題；但如果要你拿著一整天，你的手臂就會感到麻痺。那為什麼不放下它或是喝下它呢？",
              "tip": "研究顯示，即使只是輕度脫水，也會導致皮質醇水平升高。保持身體水分充足有助降低壓力水平，即刻去喝水來排減壓力吧！"
            },
            {
              "msg": "你可以做任何事，但不是所有事。",
              "tip": "你已經做得夠多了！現在要做的是要讓自己恢服體力。做運動就是讓頭腦清醒和紓解壓力的好方法！"
            }
          ]
        },
        "depress": {
          "text": "悲傷",
          "content": [
            {
              "msg": "休息，是點燃你內在光芒的強大力量。",
              "tip": "睡個好覺可以恢復體力。想好好休息，就要限制酒精和咖啡因的攝取量，以及減少吸煙。"
            },
            {
              "msg": "不是所有風暴都會摧毀你的生活，有些能為你掃除前路障礙。",
              "tip": "與好友聊天不但能令你心情變好，他們還可以針對你的處境給你建議，你或者會發現事情其實沒你想得那麼糟糕的。"
            },
            {
              "msg": "偶爾該把自己放在首位。這不是自私，而是一種必要。",
              "tip": "獨處時聽些emo的音樂是完全沒有問題的。研究發現，欣賞憂傷的曲調反而會帶來積極的感覺。即刻試聽看看是不是這樣！"
            }
          ]
        }
      },
      "tips": "小提醒:"
    },
    "playlist": {
      "comingsoon": "快將推出",
      "text": {
        "spotify": "Spotify",
        "apple": "Apple Music"
      },
      "list": {
        "excited": {
          "title": "歡樂谷",
          "spotify": "https://open.spotify.com/playlist/4dajJJd0L5rlRvCZ4eQ8Ak?si=866ada1abee7433f",
          "apple": "https://music.apple.com/hk/playlist/happy-valley/pl.u-jV890dkTDAGLRey"
        },
        "calm": {
          "title": "禪之綠洲",
          "spotify": "https://open.spotify.com/playlist/7HhGFUttmLp2RNpLnRaZUW?si=7f8b8e47db7c4147",
          "apple": "https://music.apple.com/hk/playlist/calm-land/pl.u-gxblgdRubAYjmRo"
        },
        "stress": {
          "title": "深度投入",
          "spotify": "https://open.spotify.com/playlist/7mXYfsASGV9AWSO1fXpTcH?si=95bcfd04de984747",
          "apple": "https://music.apple.com/hk/playlist/zen-oasis/pl.u-GgA5kZBcoG7B6EK"
        },
        "depress": {
          "title": "平靜之境",
          "spotify": "https://open.spotify.com/playlist/272QcTkKfZlAvCyYUs5wp2?si=1ccd3eb991ab4bf6",
          "apple": "https://music.apple.com/hk/playlist/inner-savanna/pl.u-jV890gLCDAGLRey"
        },
        "zone": {
          "title": "內在草原",
          "spotify": "https://open.spotify.com/playlist/31Tk7UIQXyFLTd5DKieTf3?si=d206fa063bc34c29",
          "apple": "https://music.apple.com/hk/playlist/in-the-zone/pl.u-kv9l29vtJYzZP38"
        }
      }
    },
    "dailyTask": {
      "title": "每日健康任務",
      "subTitle1": "完成以下任務賺取",
      "subTitle2": " 積分!",
      "expandText1": "顯示",
      "expandText2": " 項活動",
      "collapseText": "顯示較少",
      "task": {
        "Step1": "還有 ",
        "Step2": " 步",
        "StepComplete": "步行 12,500 步",
        "Water": "保持水份",
        "Breath": "呼吸紓壓",
        "Stretch": "AI運動指導",
        "Playlist": "收聽我們的專屬歌單"
      },
      "earned1": "已賺取 ",
      "earned2": " ！"
    },
    "waterGame": {
      "btnText": "保持水份",
      "btnDesc1": "飲第",
      "btnDesc2": "杯水吧",
      "timeUnit": "分鐘後喝",
      "complete1": "🎉補水達標！",
      "complete2": "做得好！👏"
    },
    "pageBtn": {
      "article": {
        "type": "健康",
        "text": "貼士及測驗"
      },
      "stretch": {
        "type": "伸展",
        "text": "AI 運動指導及職場健康"
      },
      "breath": {
        "type": "呼吸",
        "text": "呼吸紓壓"
      },
      "music": {
        "type": "收聽我們的專屬歌單",
        "text": "收聽我們的專屬歌單"
      },
      "water": {
        "type": "保持水份",
        "text": "保持水份"
      },
      "adventure": {
        "type": "健康",
        "text": "Adventure Hunt"
      }
    },
    "tutorial": {
      "btn": {
        "skip": "跳過",
        "prev": "上一步",
        "next": "下一步",
        "last": "明白了！"
      }
    }
  },
  "game": {
    "breathing": {
      "intro": {
        "title": "靜觀呼吸",
        "desc1": "深吸一口氣再慢慢呼氣，把你注意力集中在每個呼吸上。",
        "desc2": "練習時記得打開手機聲音並閉上雙眼，運用這個呼吸技巧好好練習吧！"
      },
      "btns": {
        "begin": "開始練習",
        "learn": "學習正確呼吸",
        "home": "返回主頁",
        "share": "分享練習成果"
      },
      "video": {
        "header": {
          "empty": "",
          "step_1": "剩餘3次練習",
          "step_2": "剩餘2次練習",
          "step_3": "剩餘1次練習"
        },
        "up_next": "接下來： ",
        "action": {
          "empty": "",
          "countDown1": "靜下心來",
          "countDown2": "放鬆",
          "countDown3": "開始呼吸",
          "upNextHold": "憋氣",
          "hold": "保持憋氣",
          "inhale": "吸氣",
          "exhale": "呼氣",
          "returnNormal": "恢復正常呼吸"
        }
      },
      "complete": {
        "remark": "成功解鎖主頁裝飾貼圖！",
        "title": "做得很好！",
        "desc": "你已完成一次靜觀呼吸，並調息好思緒和心情，接下來將專注力集中在當下，充分感受到這一刻為你帶來正面影響。繼續保持深呼吸，恢復自己內在的能量吧。"
      },
      "intro_detail": {
        "title": "好的呼吸需要好好練習！",
        "content_one": "我們每天約需呼吸22,000次，但並非人人都知道怎樣好好呼吸！別擔心，我們會幫助你拿捏到呼吸的藝術！<br/><br/><span class='fw-bold'>呼吸有兩種方式：胸式呼吸和腹式呼吸。但是哪一種比較好？</span><br/><br/><span>胸式呼吸，是靠胸腔部位的肌肉上舉以擴大肺的上半部來吸氣；而腹式呼吸則是透過腹部及橫隔膜移動來將肺部填滿。後者不只是更有效的呼吸方式，還能讓你的心情放鬆下來。</span><br/><span>多數人忘記怎樣的呼吸才是正確的，還會慣常使用胸式呼吸。長期依賴胸式呼吸會可能會引起頸痛、頭痛，甚至帶來焦慮和壓力症狀。</span><br/><br/><span class='fw-bold'>練習腹式呼吸：</span>",
        "step_1": {
          "title": "步驟一",
          "content": "找個地方舒適地坐下，把手放在腹部上。"
        },
        "step_2": {
          "title": "步驟二",
          "content": "透過鼻子慢慢吸氣，腹部會像顆氣球一樣膨脹。"
        },
        "step_3": {
          "title": "步驟三",
          "content": "撅起嘴唇，輕輕呼氣，就像吹泡泡一樣。持續練習時要專注於用鼻子吸氣，從嘴巴呼氣。"
        },
        "content_two": "<span class='fw-bold'>嘗試進階的呼吸練習：4-7-8放鬆呼吸法</span> <br><br> <span>先吸氣4秒，再憋氣7秒，最後呼氣8秒。這個呼吸方法有助放鬆身心，能夠改善輕度睡眠障礙、減緩焦慮及壓力。</span> <br><br> 剛開始時先練習4次就好，熟練後逐漸增加次數，完成8次完整的呼吸。<br><br> 準備好了嗎？跟我們一起練習呼吸吧！"
      },
      "share": {
        "header": "分享練習成果",
        "title": "",
        "desc1": "你的靜觀呼吸很棒！現在你擁有一顆清晰的腦袋來迎接新的一天。",
        "desc2": "連接彼此在8alance"
      }
    },
    "stretch": {
      "intro": {
        "title": "AI 運動指導",
        "desc1": "跟著手機內簡單的伸展運動，輕鬆告別頸部和肩膀的緊張感！",
        "desc2": "請確保你已打開手機音量，每完成一個動作，會發出「叮」的提示音哦。"
      },
      "video": {
        "subTitle": {
          "empty": "",
          "countDown1": "挺直背部",
          "countDown2": "放鬆肩膀",
          "countDown3": "準備伸展"
        }
      },
      "exerciseHeader": {
        "part_1": "剩餘",
        "part_2": "組伸展動作"
      },
      "exerciseStep": {
        "0": {
          "reminder": {
            "info": "很好！<br/>立即開始吧!"
          },
          "footer": {
            "title": "對準框內，開始伸展運動"
          }
        },
        "1": {
          "instruction": {
            "title": "",
            "movement": "向右傾斜",
            "desc": "慢慢地將頭傾向右邊，嘗試讓右耳貼近右肩。"
          },
          "reminder": {
            "start": "向右傾斜並保持姿勢",
            "almost": "再伸展多一點點！",
            "hold": "保持住"
          },
          "footer": {
            "title": "注意不要聳肩",
            "tips": "再保持多10秒",
            "upNext": "接下來：向左傾斜"
          }
        },
        "2": {
          "instruction": {
            "title": "",
            "movement": "向左傾斜",
            "desc": "慢慢地將頭傾向左邊，嘗試讓左耳貼近左肩。"
          },
          "reminder": {
            "start": "向左傾斜並保持姿勢",
            "almost": "再伸展多一點點！",
            "hold": "保持住"
          },
          "footer": {
            "title": "注意不要聳肩",
            "tips": "再保持多10秒",
            "upNext": "接下來：頭部前傾"
          }
        },
        "3": {
          "instruction": {
            "title": "",
            "movement": "壓低下巴",
            "desc": "先將肩膀放鬆，頭部正對前方及背部自然挺直，然後將下巴向胸部方向壓低。"
          },
          "reminder": {
            "start": "壓低下巴",
            "almost": "再伸展多一點點！",
            "hold": "保持住"
          },
          "footer": {
            "title": "保持動作緩慢順暢",
            "tips": "再保持多15秒",
            "upNext": "接下來：仰頭伸展"
          }
        },
        "4": {
          "instruction": {
            "title": "",
            "movement": "抬起下巴",
            "desc": "先將肩膀放鬆，頭部正對前方及背部自然挺直，然後再將下巴向天花板方向抬高。"
          },
          "reminder": {
            "start": "抬起下巴",
            "almost": "再伸展多一點點！",
            "hold": "保持住"
          },
          "footer": {
            "title": "保持動作緩慢順暢",
            "tips": "再保持多10秒",
            "upNext": "接下來：聳肩"
          }
        },
        "5": {
          "instruction": {
            "title": "",
            "movement": "練習上提及下沉肩膀",
            "desc": "向上提起雙肩並保持5秒，再慢慢下沉肩膀。"
          },
          "reminder": {
            "start": "向上提起",
            "almost": "再伸展多一點點！",
            "hold": "保持住"
          },
          "footer": {
            "title": "慢慢練習",
            "tips": "再保持多5秒",
            "upNext": ""
          }
        },
        "6": {
          "congrats": "做得很好！",
          "footer": ""
        }
      },
      "upNext": "",
      "complete": {
        "remark": "成功解鎖主頁裝飾貼圖！",
        "title": "做得好！",
        "desc": "有規律地伸展，不只能提高關節靈活性，還能助你輕鬆完成日常工作和活動。定期進行伸展運動來保持健康體魄吧！"
      },
      "intro_detail": {
        "title": "伸展一下<br/>感覺更好！",
        "content_one": "<span>伸展運動是一種簡單而有效的動作，有助提升身體靈活性、血液循環和改善整體健康。但在開始之前，要先了解你的身體極限，還要注意一下肌肉是否正確拉伸。以下有幾個提示給你：</span> <br/><br/> <span class='fw-bold'>動作保持輕柔</span> <br/><br/> <span>不該感到疼痛，有拉扯感即可。</span> <br/><br/> <span class='fw-bold'>要保持呼吸</span> <br/><br/> <span>呼吸要平穩，每次呼氣時讓肌肉再拉伸多一點。</span> <br/><br/> <span class='fw-bold'>注意力放在肌肉上</span> <br/><br/> <span>關鍵在於正確的姿勢及擺位。</span> <br/><br/> <span>現在，透過以下簡單的動作來開始拉伸吧：</span>",
        "tips_1": {
          "title": "向左右傾斜",
          "content": "慢慢地將頭部向左右兩側肩膀傾斜，每側保持10秒。<br/><br/>這個動作可紓緩斜角肌、胸鎖乳突肌及頭最長肌。"
        },
        "tips_2": {
          "title": "向前後傾斜",
          "content": "下巴向胸部方向壓低，保持15秒；然後抬頭，將下巴抬向天花板方向，同樣保持10秒。有需要可重複以上動作。<br/><br/>頭部向下傾斜可紓緩上斜角肌、頸夾肌及頸夾肌、頭最長肌和枕下肌；抬頭時則可紓緩頸闊肌和胸鎖乳突肌。"
        },
        "tips_3": {
          "title": "聳肩",
          "content": "向上提起雙肩並保持5秒，再慢慢下沉肩膀，整套動作重覆5次即可。<br/><br/>聳肩是針對頸部兩側斜方肌進行的伸展練習。"
        },
        "content_two": "<span class='fw-bold'>你已具備所有基礎知識！現在動起來吧，感受拉伸為你帶來的好處！</span>"
      },
      "btns": {
        "begin": "開始運動",
        "tips": "學習伸展運動",
        "learn": "學習伸展運動",
        "home": "返回主頁"
      },
      "ai_loading": {
        "title": "AI啟動中...",
        "desc": "請稍等。載入可能需時。"
      },
      "popup": {
        "no_permission": {
          "title": "沒有權限開啟相機",
          "desc": "我們現時沒有權限開啟你的相機。請先退出8alance，在手機的設定中更改相機權限後再回來。",
          "btn": "知道了"
        }
      }
    }
  },
  "popup": {
    "setting": {
      "titleAvatar": "選擇喜歡的頭像",
      "titleLang": "選擇語言",
      "langOption": {
        "tc": "䌓體中文",
        "en": "English"
      }
    },
    "generalError": {
      "title": "噢！",
      "content": "發生錯誤，稍後再試一次。",
      "btnText": "知道了"
    },
    "dailyPrize": {
      "title": "追蹤健康任務狀況",
      "weekDay": {
        "1": "星期一",
        "2": "星期二",
        "3": "星期三",
        "4": "星期四",
        "5": "星期五"
      },
      "checkInBtn": "立即簽到！",
      "checkInRemark": "每日簽到可以賺取更多B coins！"
    },
    "coins": {
      "title": {
        "first_part": "coin",
        "second_part": "是甚麼？"
      },
      "content": "B coins 是8alance的社交獎賞貨幣，你可透過完成健康任務、測驗及更多方法來賺取！立即來賺取B coins，盡享豐富的健康獎賞！<br/><br/>健康獎賞即將登場，敬請期待！"
    },
    "tokenError": {
      "title": "噢！",
      "content": "發生錯誤，稍後再試一次。",
      "btnText": "知道了"
    }
  },
  "article_quiz": {
    "header": "健康貼士及小測驗",
    "page_tab": {
      "article": "貼士",
      "quiz": "小測驗"
    },
    "btn": {
      "start_quiz": "立即開始"
    }
  },
  "challenge": {
    "empty": {
      "available": {
        "title": "沒有新的測驗",
        "desc": "密切留意住我們的新測驗吧！"
      },
      "progress": {
        "title": "太好了！",
        "desc": "你已完成所有小測驗 😉"
      },
      "completed": {
        "title": "暫時沒有測驗",
        "desc": "完成測驗來賺取更多B coins吧！"
      }
    },
    "correct_answer": "檢查你的答案",
    "success": "<span class='title'>完美！</span><span class='result'>{complete}/<span class='total'>{total}</span></span><span class='correct'></span>",
    "goodjob": "<span class='title'>做得好！</span><span class='result'>{complete}/<span class='total'>{total}</span></span><span class='correct'></span>",
    "fail": "<span class='title'>下次再接再厲！</span><span class='result'>{complete}/<span class='total'>{total}</span></span><span class='correct'></span>",
    "point": "你已賺取到<br/><div class='point'>{point} 獎賞</div>",
    "question": "第 {index} 題",
    "filter": {
      "available": "可參加",
      "in_progress": "進行中",
      "completed": "已完成"
    },
    "cta": {
      "prev": "返回",
      "next": "繼續",
      "done": "完成"
    },
    "earned": "成功解鎖主頁裝飾貼圖！",
    "actions": {
      "backHome": "返回主頁",
      "backListing": "更多測驗",
      "share": "分享結果"
    }
  },
  "bookmark": {
    "header": "收藏文章",
    "empty": {
      "title": "沒有收藏文章",
      "desc": "去發掘你喜歡的文章吧 "
    }
  },
  "vitalResult": {
    "any": "任何",
    "range": "範圍",
    "condition": "狀態",
    "label": {
      "generalWellness": "綜合健康",
      "generalWellnessDesc": "綜合健康分數是以主要生命體徵和精神壓力水平的加權分數來計算。<br/><br/>正常的綜合健康分數為80-100。",
      "generalWellnessPopupDesc": "正常的綜合健康分數為80-100。",
      "stress": "壓力水平",
      "stressDesc": "壓力是一種情緒或身體緊張的感覺。 任何讓您感到沮喪、憤怒或緊張的事件或想法，或會導致壓力增加。<br/><br/>正常的靜息壓力等級為 0-2。",
      "stressPopupDesc": "正常的靜息壓力等級為 0-2。",
      "respiratoryRate": "呼吸頻率",
      "respiratoryRateDesc": "呼吸頻率為一個人每分鐘呼吸的次數。 呼吸頻率可能會因隨著運動、喘氣、焦慮等狀況而上升。<br/><br/>成年人靜息時正常呼吸頻率為每分鐘 12至20次。 ",
      "respiratoryRatePopupDesc": "成年人靜息時正常呼吸頻率為每分鐘 12至20次。",
      "respiratoryRateUnit": "BPM",
      "spo2": "血氧飽和度",
      "spo2Desc": "血氧飽和度是紅血球從肺部攜帶到身體其他部位的氧氣量。 低血氧症可能由導致血液循環或呼吸困難症狀的潛在疾病引起。<br/><br/>大多數人的血氧飽和度為95% 或以上。",
      "spo2PopupDesc": "大多數人的血氧飽和度為95% 或以上。",
      "spo2Unit": "%",
      "heartRate": "心率",
      "heartRateDesc": "心率是每分鐘心臟跳動的次數 (bpm)。高心率可能是由荷爾蒙問題、焦慮、大量攝入咖啡因/酒精、貧血等引起的。<br/><br/>正常的靜息心率範圍為每分鐘60-80次。",
      "heartRatePopupDesc": "正常的靜息心率範圍為每分鐘60-80次。",
      "heartRateUnit": "BPM",
      "hrvSdnn": "心率變異度（SDNN值）",
      "hrvSdnnDesc": "心率變異度是每次心跳之間的時間差異。SDNN 是正常心跳間距的標準偏差。低心率變異度可能是由睡眠不足的壓力造成。<br/><br/>35毫秒以上的心率變異度SDNN 是健康的。",
      "hrvSdnnPopupDesc": "35毫秒以上的心率變異度SDNN 是健康的。",
      "hrvSdnnUnit": "MS",
      "bloodPressure": "血壓",
      "bloodPressureDesc": "血壓度數以兩組數字表達，首個數字為收縮壓／上壓，顯示心臟收縮泵出血液時血管內的壓力，而第二個數字為舒張壓／下壓，則表示在心跳之間，心臟放鬆時血管內的壓力。<br/><br/>理想的血壓為上壓（收縮壓）持續低於120 mmHg，下壓（舒張壓）持續低於80 mmHg。",
      "bloodPressurePopupDesc": "理想的血壓為上壓（收縮壓）持續低於120 mmHg，下壓（舒張壓）持續低於80 mmHg。",
      "bloodPressureUnit": "mmHG"
    },
    "result_title": " 你的生命體徵",
    "check_my_record_today": "查看最近紀錄",
    "check_my_record_before": "查看最近紀錄",
    "monitor_health": "即刻掃描你的健康狀況吧！",
    "homeTxt": {
      "Poor": "放鬆一下，善待自己 <img src='/images/vitalScan/Relieved Face.svg' alt=''>",
      "Good": "還不錯！<br/>身心可以更平衡！<img src='/images/vitalScan/Clapping Hands.svg' alt=''>",
      "Excellent": "今天狀態很好呢！<img src='/images/vitalScan/Clapping Hands.svg' alt=''>"
    },

    "date": "記錄日期： {date}",
    "providedBy": "專業支援由港怡醫院提供",
    "rescan": "重新掃描",
    "cover": {
      "Excellent": "狀態很好呢！ <img src='/images/vitalScan/Clapping Hands.svg' alt=''>",
      "Good": "還不錯！<br/>身心可以更平衡！<img src='/images/vitalScan/Clapping Hands.svg' alt=''>",
      "Poor": "放鬆一下，善待自己 <img src='/images/vitalScan/Smiling Face With Smiling Eyes.svg' alt=''>"
    },

    "title": "你的生命體徵",
    "desc": "點擊以下數據來了解更多。",
    "Excellent": "理想",
    "Good": "良好",
    "Normal": "正常",
    "Bad": "Bad",
    "Worse": "Worse",
    "BelowAverage": "偏低",
    "AboveAverage": "偏高",
    "AtRisk": "欠佳",
    "Poor": "較差",
    "Hypertension": "高血壓",
    "HighNormal": "正常偏高",
    "Optimal": "理想",
    "Or": "OR",
    "detailPage": {
      "commonText": {
        "latest": "最近",
        "average": "最近7日平均",
        "noRecord": "No Record here",
        "doVitalScan": "Do Vital scan now",
        "trend": "最近7日紀錄"
      },
      "tips": {
        "label": "Tips:"
      }
    },
    "recommendCard": {
      "title": "為你推薦"
    },
    "suggestions": {
      "generalWellness": {
        "Excellent": {
          "title": "富足心靈，豐盈人生",
          "desc": "多與人分享想法、培養正向思維及擁抱生活的喜悅，保持健康心理及安定感有助延長壽命。"
        },
        "Good": {
          "title": "關注健康，展現活力",
          "desc": "每日運動30分鐘，有效增強免疫力及促進健康。不想花錢做運動？行樓梯是一個好選擇！"
        },
        "Poor": {
          "title": "謹慎地作出選擇",
          "desc": "要改善健康，就要選擇無煙生活、多元化的營養飲食及適量飲酒。（註：飲酒越多，影響健康的風險越高）"
        }
      },
      "stress": {
        "Excellent": {
          "title": "身心充電，健康成長",
          "desc": "定期安排些能令自己開心及滿足的活動或愛好，好好滋養自己的心靈。還要平衡工作與玩樂，當中所獲的成就感能讓你更添活力。"
        },
        "Good": {
          "title": "掌握效率，擺脫壓力",
          "desc": "將複雜任務拆分成數個細小的任務能有效管理壓力。逐步完成小任務，離成功也不遠了！"
        },
        "Poor": {
          "title": "培養身體的復原力",
          "desc": "建立正面學習、身心鬆弛練習、定期運動、均衡飲食及保持充足睡眠的生活習慣。"
        }
      },
      "respiratoryRate": {
        "BelowAverage": {
          "title": "深呼吸，放輕鬆",
          "desc": "進行放鬆練習，例如是腹腔式呼吸，有助你管理壓力及達至放鬆的效果。"
        },
        "Excellent": {
          "title": "恆常運動，放鬆身心",
          "desc": "定期運動能為你的健康帶來意想不到的好處，試試看將伸展運動或散步成為你日常的一部分吧。"
        },
        "AboveAverage": {
          "title": "用呼吸感受當下",
          "desc": "學習放鬆訓練及靜觀步行，以更慢、更有效的呼吸模式來幫你達至心理平靜及保持頭腦清晰。"
        }
      },
      "spo2": {
        "BelowAverage": {
          "title": "跑出健康人生",
          "desc": "偶爾慢跑，能讓身體保持良好的血氧飽和度，每一步都能增加血氧量及加快新陳代謝。"
        },
        "Normal": {
          "title": "跑出健康人生",
          "desc": "偶爾慢跑，能讓身體保持良好的血氧飽和度，每一步都能增加血氧量及加快新陳代謝。"
        }
      },
      "heartRate": {
        "BelowAverage": {
          "title": "提升運動水平",
          "desc": "增加運動強度有助提高心率、燃燒更多卡路里，還能更有效控制體重。"
        },
        "Normal": {
          "title": "邁向健康飲食方式",
          "desc": "你進食的食物會影響到你的健康。優先選擇低鈉、低脂肪、低糖及高纖維的食物，營養豐富的食物能為你的身體提供能量。"
        },
        "AboveAverage": {
          "title": "進行心肺功能訓練",
          "desc": "每星期5日，每次30分鐘的帶氧運動，有助提升你的健康水平，好好鍛練心肺功能，提升心肺耐力。"
        }
      },
      "hrvSdnn": {
        "AtRisk": {
          "title": "好好休息，復原身心",
          "desc": "面對壓力，心率變異度通常會下降。優先考慮休息並留出恢復時間，幫助提升心率變異度。"
        },
        "Poor": {
          "title": "好好休息，復原身心",
          "desc": "面對壓力，心率變異度通常會下降。優先考慮休息並留出恢復時間，幫助提升心率變異度。"
        },
        "BelowAverage": {
          "title": "好好休息，復原身心",
          "desc": "面對壓力，心率變異度通常會下降。優先考慮休息並留出恢復時間，幫助提升心率變異度。"
        },
        "Good": {
          "title": "休息才能恢復活力",
          "desc": "面對壓力，心率變異度通常會下降。優先考慮休息並留出恢復時間，幫助提升心率變異度。"
        },
        "Excellent": {
          "title": "休息才能恢復活力",
          "desc": "面對壓力，心率變異度通常會下降。優先考慮休息並留出恢復時間，幫助提升心率變異度。"
        }
      },
      "bloodPressure": {
        "Hypertension": {
          "title": "逐步控制血壓",
          "desc": "戒煙、限制飲酒、保持健康體重及注意飲食。運動方面應循序漸進，逐步增加你的運動強度和持續時間。"
        },
        "HighNormal": {
          "title": "建立健康生活習慣",
          "desc": "以香草、香料或其他替代食鹽來烹調食身。 需戒煙及限制飲酒、鍛煉身體以保持心境輕鬆及血管彈性。"
        },
        "Normal": {
          "title": "保持腰圍呎寸",
          "desc": "男性腰圍應保持90厘米以下、女性腰圍應保持在80厘米以下。透過健康飲食和避免久坐，有助維持心臟健康！"
        },
        "Optimal": {
          "title": "內在和諧，擁抱寧靜",
          "desc": "透練習過瑜伽、太極、深呼吸技巧及安寧睡眠等減壓方法，讓身心實現平衡、和諧和自癒力。"
        }
      }
    }
  },
  "vital_scan": {
    "header": "準備掃描",
    "reminder_1": "掃描即將開始，請確保符合以下要求",
    "reminder_2": "放輕鬆吧",
    "remark": "請放心，我們不會儲存你的臉部識別資訊。",
    "condition": {
      "light": "充足光源",
      "distance": "適當距離",
      "face_position": "對準相框",
      "camera_status": "穩定拍攝"
    },
    "loading": "掃描進行中⋯⋯",
    "btn": {
      "start": "開始掃描"
    },
    "error_popup": {
      "frame_rate": {
        "title": "噢！裝置不相容。",
        "desc": "你使用的手機型號與生命體徵監測程式不相容，請用另一個裝置嘗試。",
        "btn": "知道了"
      },
      "server": {
        "title": "抱歉，出現問題了",
        "desc": "請休息一會兒，刷新頁面重試吧！",
        "btn": "知道了"
      },
      "rescan": {
        "title": "哎呀！需要重新掃描",
        "desc": "請跟著下方的指引稍作調整並再試試看吧：",
        "btn": "知道了",
        "rule": {
          "calm": "請保持心情平靜舒適",
          "distance": "請在光線充足的環境下進行掃描，保持姿勢及距離穩定",
          "device": "請使用另一部性能較佳的裝置進行掃描，或稍後再試"
        }
      },
      "no_permission": {
        "title": "沒有權限開啟相機",
        "desc": "我們現時沒有權限開啟你的相機。請先退出8alance，在手機的設定中更改相機權限後再回來。",
        "btn": "知道了"
      }
    },
    "disclaimer": {
      "title": "免責聲明",
      "desc": "<b>相關原理</b><br/><br/>本程式內的健康監測功能是透過相機鏡頭掃描面部，而非接觸式方法測量心率、呼吸頻率、血壓和血氧飽和度等生命體徵。用戶設備上的相機鏡頭會拍攝影片僅作健康數據計算之用，並不會儲存任何影片片段。<br/><br/>此功能不可用作測量生命體征的唯一方式，並不能取代與醫護人員的資訊會診。<br/><br/>此功能只適合18歲或以上人士使用，所收集的生命體徵數據僅作參考用途，並且不適用於診斷疾病或其他健康狀況，或用於預防或治療疾病。<br/><br/>新創、港怡醫院及其程式開發商不保證此功能測量的健康數據之可用性、準確性及完整性。<br/><br/>如果您有任何健康問題，請立即諮詢你的醫生或其他專業醫療人員。<br/><br/><b>數據處理</b><br/><br/>提供以上生物辨識資料是自願的，未能提供此類生物辨識資料將無法使用此健康觀察功能。<br/><br/>收集的生物辨識資料可能會被移轉予第三方服務供應商，包括但不限於PANOPTICAI LIMITED及其承包商，以用作於數據的分析，而此等分析將以加密形式存儲，並且將無法把數據與特定的人士聯繫起來。<br/><br/>我們將確保生物辨識資料的收集將不會對你的個人權利和自由有任何不利影響，亦不會使用所提供的生物辨識資料對其個人作出不利行動。<br/><br/>PANOPTICAI LIMITED及其承包商將定期刪除以收集的生物辨識資料。如果你希望要求查閱、改正或刪除生物辨識資料，你可通過發送電子郵件到8alance&#64;ctflife.com.hk 或寫信給我們的保障資料主任（地址：周大福人壽保險有限公司，九龍觀塘海濱道123號綠景NEO大廈7樓）（標記為機密）。根據香港法例第486章《個人資料（私隱）條例》( “《私隱條例》” )，我們有權就處理任何個人資料查閱請求向您收取合理費用。",
      "checkbox_txt": "當我開始使用這功能，即表示我以閱讀並接受相關條款及細則。",
      "btn": "明白"
    }
  },
  "tnc": {
    "title": "條款及細則",
    "desc": "<b>引言</b><br/><br/>周大福人壽保險有限公司（「我們」或「本公司」)推出“<b>8alance</b>”這個大眾身心健康推廣移動平台(“本平台”)，透過嶄新科技、運動科學及醫療資訊，提高本港市民對健康的關注和狀態。<br/><br/><b>接受本使用條款</b><br/><br/>你（會員）繼續使用本平台前必須細閱下列資料。你凡取覽本平台及當中的任何網頁，即表示已閱讀下列資料，並接受下述及另載於本平台之相關網頁的條款及細則，亦同意受此等條款及細則約束。倘若你不同意下列條款及細則，請勿瀏覽本平台或當中的任何網頁。<br/><br/><b>使用條款</b><br/><br/><b>1. 授權會員</b><br/><br/>你必須保留用戶代號及密碼為個人使用，並將資料保密及定期為戶口更改密碼。你需要對戶口內的一切行為負責。如戶口被人盜用或懷疑被盜用，你必須盡快通知本公司。<br/><br/>若你為 8alance 用戶，則使用同一賬戶。<br/><br/><b>2. 用戶操守</b><br/><br/>你在本平台中只可進行個人及非商業性質的活動，你須對不論在本平台上或經由本平台所公開發布或私下傳送的所有資訊、數據、文字、軟件、音樂、聲響、照片、圖象、影像、錄像、信息、標誌、按鈕圖象、HTML 碼，以及網站中展示的其他材料（“內容”）全權負責。<br/><br/>作為你使用本平台的條件之一，你不得將本平台作任何違法、與上述用途無關或任何適用法規或本平台中任何條款、條件及通知所禁止的用途。在上述各項通用的原則下，你不可：<br/><br/>(i) 未經本公司批准而擅闖、闖進、進入、使用，或試圖擅闖、闖進、進入或使用本公司伺服器的任何其他部分或任何與網站相關的資料區；<br/><br/>(ii) 經由本平台上載、發表、以電郵發放、出版、傳送，或提供任何非法、詐騙、不當、誹謗、中傷、不雅、淫褻、褻瀆、威脅、騷擾、侮辱、討厭、冒犯，或惹人反感或無理的任何內容，包括足以構成或鼓動刑事罪行，民事訴訟，或有違任何地方、國家、或外國法規，或違反知識產權、專利權或其他有關方面保密權責行為的傳送;<br/><br/>(iii) 經由本平台上載、發表、以電郵發放、出版、傳送，或提供任何廣告 (本公司提供的促銷活動或優惠推廣除外)、徵求、垃圾電郵、連鎖信件、層壓式計劃、投資機會或計劃，或任何非應邀的商業通訊；<br/><br/>(iv)   發表、出版、傳送、複製、分發，或利用任何經本平台取得的內容作商業用途；<br/><br/>(v)    下載、發表、出版、傳送、複製，或以任何方式分發經本平台取得的任何受版權或其他任何第三者專利權法規保護的網站組成部分或內容，或未經本公司書面准許而從中衍生任何創作；<br/><br/>(vi)   經由本平台上載、發表、以電郵發放、出版、傳送，或提供包含病毒、特洛伊木馬程序、蠕蟲病毒、定時炸彈、刪除蠅，或任何其他為中斷、破壞或限制任何電腦軟件或硬件或電訊設備而設計的有害電腦密碼、檔案或程序；<br/><br/>(vii) 在本平台上或經由本平台上載、發表、以電郵發放、出版、傳送，或提供受知識產權法、私隱或宣傳權或任何其他適用法規保護的內容，除非你擁有或控制一切有關權利或事前已獲得各有關方面同意；<br/><br/>(viii) 干擾或擾亂連接本平台的網絡或違反此等網絡的規則、政策或程序；<br/><br/>(ix)   試圖以破解密碼或任何其他方法未經許可而接入本平台、電腦系統或連接本平台的網絡；<br/><br/>(x)    騷擾其他使用者；<br/><br/>(xi)   收集或儲存有關其他使用者的個人資料；或<br/><br/>(xii) 假冒任何人或實體或虛假陳述或歪曲你與某人或某實體的聯繫。<br/><br/><b>3. 監督權</b><br/><br/>本公司保留權力在任何其認為適當的時間監督使用情況，並在本公司全權決定下清除本平台可能是非法或不正確、可能產生本公司的賠償責任、可能違反使用協議條款，或在本公司全權決定下不符合本平台目的之任何內容。<br/><br/><b>4. 連結其他網站</b><br/><br/>本平台可能載有超連結，連接到第三方操作的互聯網站和資源，這些連結的網站由非本公司之他方運營，並不受本公司控制。本公司將不會就連結至其他網站之內容及其架構負責。你需為進入及使用這些網站負上風險並遵守其所訂立之進入/使用條款及條件。本平台為用戶提供其他網站之連結，並不代表其內容為本公司之立場，亦不代表本公司推薦、批准、保薦或介紹其網站內提供的任何服務/產品，及不代表本公司與此第三者及網站具有任何合作形式。本公司不涉及你與這些網站的任何合作或交涉。<br/><br/>對於因你或據稱因你使用或依賴該等網站上提供的任何內容、貨品或服務而引致的任何直接或間接損失或損害賠償，本公司概不負責，也不承擔任何法律責任。任何有關外部連結的問題應發給相關的網站管理人或主持人。<br/><br/>本平台亦可能載有第三方廣告，當中嵌入了超連結接到第三方網站。所有該等廣告非本公司推薦或認可。<br/><br/><b>5. 資料及討論內容</b><br/><br/>本平台之內容有可能由第三者供應商或由其他參考資料或來源選取，這些在本平台之內容不可視為本公司之推薦或對於任何人士、產品或服務之立場。本公司對該等資訊不承擔任何責任。使用及依賴該等資訊的風險由閣下承擔。<br/><br/>除另有說明外，於本平台「分享」中或其他相類似的頁面的留言或群組內之觀點、評論及意見（“討論內容”）均不代表本公司之觀點或任何立場。你需對這些留言或群組內發表之意見的可靠性及準確性提高警覺。一切的資訊包括資料、文字、圖像信息或其他資料，無論其為公開張貼或私下傳送，均為起始資料提供者之責任。<br/><br/>在任何情況下，本公司均不為任何討論內容負責，此內容包括但不限於任何討論內容之任何錯誤或遺漏，以及經由本平台張貼、發送電子郵件或傳送而衍生之任何損失或損害。本公司保留移除、審查及拒絕張貼於本平台之討論內容的權利而不作任何事前通知。<br/><br/><b>6. 知識產權</b><br/><br/>本平台內所有知識產權均屬於本公司或已經由本公司取得許可使用。本公司有可能再宣傳或複製本平台，對於因本平台上提供的內容或再宣傳或複製的內容而引致的任何損失或損害賠償，本公司概不負責。在沒有本公司的允許下，該等內容的任何部分均不得上載、張貼、刊登、複製、傳送、再版、分發或作出衍生作品。<br/><br/>你同意本平台可以任何方式、媒體及形式自由使用、披露、採用及修改你向本平台所提供之意見、意念、技術、建議、提議、批評及任何溝通及資料(“回應”)，而毋需向你承擔任何責任。你保證閣下已就為令本公司使用你的回應取得必要的所有轉讓、豁免、免除責任及同意。<br/><br/><b>7. 彌償</b><br/><br/>由於你違反使用條款及/或使用本平台或閣下在本平台上的行為、你在本平台上或通過本平台發佈或傳送的內容或消息有關或因此而產生的任何責任、索償、訴訟、費用及支出，概由你作出彌償並使本公司不遭受任何損失。本公司保留權利由其自負費用獨自對應由你彌償的任何事項進行辯護和控制，但這不應免除你的彌償義務。<br/><br/><b>8. 活動及福利兌換及享用</b><br/><br/>你只能在我們可能不時規定的指定地點申領福利及活動，而我們有權就該等福利及活動作出最終決定。<br/><br/>我們並非福利及活動之供應商，你應受可能不時適用於任何福利的條款及條件規限。任何有關該等福利及活動索賠或投訴，應直接向有關的供應商提出。我們不就有關事宜承擔任何責任/法律責任。<br/><br/>所有福利及活動的授予均視乎供應情況而定，額滿即止（如適用）。<br/><br/>我們保留向你授予福利的權利及所有最終決定權，僅在我們確認你的帳戶有效且狀態良好時。<br/><br/>一旦我們接受你的任何兌換申請，你將不能更改或取消其兌換申請。<br/><br/>你申領任何福利及活動時，我們及指定供應商有權要求你出示你的電子卡。如有需要，我們亦有權要求你出示其他身份證明文件，以核實身份。<br/><br/><b>9. 獎勵兌換</b><br/><br/>你透過此本平台申請兌換獎勵。我們可根據 (其中包括) 你在本平台的積分是否足夠以及獎勵的供應情況等來決定是否接受或拒絕此類申請。<br/><br/>我們並非獎勵之供應商，你應受可能不時適用於任何福利的條款及條件規限。任何有關該等獎勵索賠或投訴，應直接向有關的供應商提出。我們不就有關事宜承擔任何責任/法律責任。<br/><br/>我們保留向你授予獎勵的權利及所有最終決定權，僅在我們確認你的帳戶有效且狀態良好時。<br/><br/>你可以根據指定供應商不時適用的條款及條件兌換獎勵。<br/><br/>在成功兌換獎勵後，我們可就特定獎勵將一次性二維碼存入你於本平台的帳戶。持有人有權憑二維碼在指定有效期內到指定地點兌換獎勵。<br/><br/>獎勵以先到先得方式提供，額滿即止。<br/><br/>獎勵及二維碼不能兌換為現金或其他禮品。<br/><br/>特定條款及條件可能適用於每項獎勵及發放的二維碼。<br/><br/><b>10. 使用條款修訂</b><br/><br/>本公司將不時修改使用條款而不會作另行通知。如在修訂條款後你繼續使用本網站，即代表你同意受此等修訂之約束。<br/><br/><b>11. 對服務的修改</b><br/><br/>本公司有權隨時未經通知修改或暫停或永久終止本平台或其中任何部分。你同意就本平台或其中任何部分的任何修改、暫停或終止，本公司毋須向你或任何第三者負責。<br/><br/><b>12. 免責聲明</b><br/><br/>本平台乃根據〝所見現狀〞及〝所能提供〞的基礎條件下提供，你因使用網站而導致的一切後果，概須自行承擔。本平台僅供你個人及非商業性質有關使用，本公司不發表任何聲明或作出任何保證，無論是明示的或暗示的，包括但不限於任何不侵權、可商售性、準確或就某目的的適用性的保證。由於您的情況與其他用戶不同，本平台的內容或不可視作具體推薦或建議。本公司不擔保或者承擔下列任何責任：<br/><br/>(i)       本平台提供的資訊是否準確、充足、及時或可靠，或是否除一般參考外還可用於任何目的；<br/><br/>(ii)      本平台提供的資訊是否無缺陷、錯誤、遺漏、病毒或可改變、刪除、增加或損壞閣下的軟件、資料或者設備的任何有害物；<br/><br/>(iii)     經互聯網發出的訊息不會被截、中斷或丟失；<br/><br/>(iv)     接通時，本平台可用或者不中斷；<br/><br/>(v)      本平台的缺點會被糾正；或<br/><br/>(vi)     本平台或提供平台的伺服器沒有病毒或其他有害成分；通過本平台傳送的訊息將能維持保密。<br/><br/>(vii)     在完全或部分基於平台內容而採取任何行動或決定前，您應該對該內容進行獨立檢查。您亦應該在適當的情況下尋求專業建議，例如醫療建議。<br/><br/>(viii)    在任何情況下，本公司對你或者任何其他人士因使用或不能使用該等資訊所發生的任何直接的、間接的、附帶引起的、特別的、懲罰性的或者間接性的損失(包括任何業務或盈利的損失)，不承擔任何責任。你在使用或者解釋該等資訊時，應只運用並依賴自己的技能和判斷。你有責任確保使用該等資訊須遵守所有適用的法律規定。<br/><br/><b>13. 系統使用</b><br/><br/>本公司不保證你能在不受干擾、持續或安全的情況下進入本平台。部分或整個平台可能突然在任何時段內或因各種原因不能使用，其中包括系統失靈或中斷、互聯網停機或其他技術故障；本公司對此等原因並無控制權，亦概不負責。你同意自行承擔使用本平台的一切相關風險，亦不就你因任何原因無法使用本平台而引致的任何損害或損失，向本公司追究責任。本公司有權基於種種原因將部分或整個平台離線，其中包括系統維修或升級。<br/><br/><b>14. 終止服務</b><br/><br/>本公司有完全酌情權在發出或不發出通知的情況下以任何理由決定終止或暫停你使用本平台全部或部分之服務，包括但不限於違反本平台的使用條款，或你於一定時間未有使用本平台之服務。本公司不會為你或任何第三者承擔因終止服務所涉及任何索償的責任。<br/><br/><b>15. 條款的分割性</b><br/><br/>如果任何條款被具有司法管轄權區的法院認為不合法或無法強制執行，亦不會影響其餘條款的效力及可強制執行性。<br/><br/><b>16. 適用法律及司法管轄權</b><br/><br/>使用條款受香港特區政府之法律規限，對於任何與本平台相關的任何爭議，你同意接受香港法院的非專屬司法管轄權。<br/><br/><b>17. 語言</b><br/><br/>如使用條款中、英文兩個版本有任何抵觸或不相符之處，應以英文版本為準。<br/><br/><b>18. 第三方權益</b><br/><br/>儘管有香港法例第623章“合約（第三者權利）條例”的規定，本使用條款是本公司與閣下的協議，僅為本公司與閣下之間的利益而作出，並非為向第三方產生或給予任何權利或聲稱賦予任何利益。 任何人士若非本條款及細則的一方，不可根據《合約（第三者權利）條例》（香港法例第623章）強制執行本條款及細則的任何條文。本公司與閣下於本使用條款之終止、撤銷、同意任何修訂、豁免、變更或解決方案的權利，均不受制於任何第三方的同意。<br/><br/><b>19. 私隱政策聲明</b><br/><br/>我們將根據香港法例《個人資料（私隱）條例》及我們的私隱政策聲明處理所有個人資料。請在此處參閱我們的私隱政策聲明：<a href='/tc/privacy-policy.html'>私隱政策</a> 。<br/><br/>會員在申請會籍時應同意我們的《個人資料收集聲明》，該聲明列明了我們在收集、持有和使用與我們有關的個人資料方面的私隱政策和做法。<br/><br/>如果會員有任何疑問，或希望查閲或更正我們持有的其個人資料，請聯絡我們的個人資料私隱專員：<br/><br/>周大福人壽保險有限公司<br/>九龍觀塘海濱道123號綠景NEO大廈7樓<br/><br/>聯絡人：<br/><br/>個人資料私隱專員<br/>（標記為保密資料)<br/><br/><a href=\"/tc/pics\"class=\"primary\" >個人資料收集聲明</a><br/><br/>本聲明受香港法律約束並據其進行解釋。<br/><br/>我已閱讀並理解以上周大福人壽保險有限公司的《個人資料收集聲明》。",
    "home_desc": "<br><br><p><strong>引言</strong></p><p>周大福人壽保險有限公司（「我們」或「本公司」）推出<strong>&ldquo;8alance&rdquo;</strong>這個企業員工身心健康推廣移動平台（&ldquo;本平台&rdquo;），透過嶄新科技、運動科學及醫療資訊，提高企業員工對身心健康的關注和及身體狀態。</p><p>&nbsp;</p><p><strong>接受本使用條款</strong></p><p>你繼續使用本平台前必須細閱下列資料。你凡取覽本平台及當中的任何網頁，即表示已閱讀下列資料，並接受下述及另載於本平台之相關網頁的條款及細則，亦同意受此等條款及細則約束。倘若你不同意下列條款及細則，請勿瀏覽本平台或當中的任何網頁。</p><p>&nbsp;</p><p><strong>使用條款</strong></p><p>1. 授權用戶</p><p>你必須保留用戶代號及密碼為個人使用，並將資料保密及定期為戶口更改密碼。你需要對戶口內的一切行為負責。如戶口被人盜用或懷疑被盜用，你必須盡快通知本公司。 </p><p>&nbsp;</p><p>2. 用戶操守</p><p>你在本平台中只可進行個人、非商業性質與非工作有關的活動，你須對不論在本平台上或經由本平台所公開發布或私下傳送的所有資訊、數據、文字、軟件、音樂、聲響、照片、圖象、影像、錄像、信息、標誌、按鈕圖象、HTML 碼，以及網站中展示的其他材料（&ldquo;內容&rdquo;）全權負責。 </p><p>作為你使用本平台的條件之一，你不得將本平台作任何違法、與上述用途無關或任何適用法規或本平台中任何條款、條件及通知所禁止的用途。在上述各項通用的原則下，你不可： </p><p>(i)&nbsp;&nbsp; 未經本公司批准而擅闖、闖進、進入、使用，或試圖擅闖、闖進、進入或使用本公司伺服器的任何其他部分或任何與網站相關的資料區； </p><p>(ii)&nbsp;&nbsp; 經由本平台上載、發表、以電郵發放、出版、傳送，或提供任何非法、詐騙、不當、誹謗、中傷、不雅、淫褻、褻瀆、威脅、騷擾、侮辱、討厭、冒犯，或惹人反感或無理的任何內容，包括足以構成或鼓動刑事罪行，民事訴訟，或有違任何地方、國家、或外國法規，或違反知識產權、專利權或其他有關方面保密權責行為的傳送；</p><p>(iii)&nbsp;&nbsp; 經由本平台上載、發表、以電郵發放、出版、傳送，或提供任何廣告 (本公司提供的促銷活動或優惠推廣除外)、徵求、垃圾電郵、連鎖信件、層壓式計劃、投資機會或計劃，或任何非應邀的商業通訊； </p><p>(iv)&nbsp;&nbsp; 發表、出版、傳送、複製、分發，或利用任何經本平台取得的內容作商業用途； </p><p>(v)&nbsp;&nbsp; 下載、發表、出版、傳送、複製，或以任何方式分發經本平台取得的任何受版權或其他任何第三者專利權法規保護的網站組成部分或內容，或未經本公司書面准許而從中衍生任何創作； </p><p>(vi)&nbsp;&nbsp; 經由本平台上載、發表、以電郵發放、出版、傳送，或提供包含病毒、特洛伊木馬程序、蠕蟲病毒、定時炸彈、刪除蠅，或任何其他為中斷、破壞或限制任何電腦軟件或硬件或電訊設備而設計的有害電腦密碼、檔案或程序；</p><p>(vii)&nbsp;&nbsp; 在本平台上或經由本平台上載、發表、以電郵發放、出版、傳送，或提供受知識產權法、私隱或宣傳權或任何其他適用法規保護的內容，除非你擁有或控制一切有關權利或事前已獲得各有關方面同意； </p><p>(viii)&nbsp;&nbsp; 干擾或擾亂連接本平台的網絡或違反此等網絡的規則、政策或程序；</p><p>(ix)&nbsp;&nbsp; 試圖以破解密碼或任何其他方法未經許可而接入本平台、電腦系統或連接本平台的網絡； </p><p>(x)&nbsp;&nbsp; 騷擾其他使用者；</p><p>(xi)&nbsp;&nbsp; 收集或儲存有關其他使用者的個人資料；或</p><p>(xii)&nbsp;&nbsp; 假冒任何人或實體或虛假陳述或歪曲你與某人或某實體的聯繫。</p><p>&nbsp;</p><p>3. 資料保密</p><p>(i)&nbsp;&nbsp; 除了在公共領域已出現或打算共享的市場推廣材料外，本平台可供給你使用的資訊內容，包括但不限於 &ldquo;公司動態&rdquo; ， 無論何種方式或存儲方法，無論這些信息是否被標記為機密信息，均屬保密資料 （統稱&ldquo;機密信息&rdquo;），只供用戶個人及非工作有關使用； </p><p>(ii)&nbsp;&nbsp; 未經本公司事先書面許可，你不得以任何方式下載，發表，公開，傳送，複製或散佈本平台裏的任何成份、任何內容細節或機密信息； </p><p>(iii)&nbsp;&nbsp; 你必須把所有機密資料保持嚴格保密，並不會直接或間接向任何人披露機密信息的存在或其他事實或與此相關的任何機密信息； </p><p>(iv)&nbsp;&nbsp; 上述限制不適用於因閣下違約以外的其他原因而被公開或將會被公開的任何資料。 </p><p>&nbsp;</p><p>4. 監督權</p><p>本公司保留權力在任何其認為適當的時間監督使用情況，並在本公司全權決定下清除本平台可能是非法或不正確、可能產生本公司的賠償責任、可能違反使用協議條款，或在本公司全權決定下不符合本平台目的之任何內容。 </p><p>&nbsp;</p><p>5. 連結其他網站</p><p>本平台可能載有超連結，連接到第三方操作的互聯網站和資源，這些連結的網站並非由本公司控制。本公司將不會就連結至其他網站之內容及其架構負責。你需為進入及使用這些網站負上風險並遵守其所訂立之進入/使用條款及條件。本平台為用戶提供其他網站之連結，並不代表其內容為本公司之立場，亦不代表本公司推薦、批准、保薦或介紹其網站內提供的任何服務/產品，及不代表本公司與此第三者及網站具有任何合作形式。本公司不涉及你與這些網站的任何合作或交涉。</p><p>&nbsp;</p><p>對於因你或據稱因你使用或依賴該等網站上提供的任何內容、貨品或服務而引致的任何直接或間接損失或損害賠償，本公司概不負責，也不承擔任何法律責任。任何有關外部連結的問題應發給相關的網站管理人或主持人。 </p><p>&nbsp;</p><p>本平台亦可能載有第三方廣告，當中嵌入了超連結接到第三方網站。所有該等廣告非本公司推薦或認可。 </p><p>&nbsp;</p><p>6. 資料及討論內容</p><p>本平台之內容有可能由第三者供應商或由其他參考資料或來源選取，這些在本平台之內容不可視為本公司之推薦或對於任何人士、產品或服務之立場。本公司對該等資訊不承擔任何責任。使用及依賴該等資訊的風險由閣下承擔。 </p><p>&nbsp;</p><p>除另有說明外，於本平台讚賞中或其他相類似的頁面的留言或群組內之觀點、評論及意見（&ldquo;討論內容&rdquo;）均不代表本公司之觀點或任何立場。你需對這些留言或群組內發表之意見的可靠性及準確性提高警覺。一切的資訊包括資料、文字、圖像信息或其他資料，無論其為公開張貼或私下傳送，均為起始資料提供者之責任。</p><p>&nbsp;</p><p>在任何情況下，本公司均不為任何討論內容負責，此內容包括但不限於任何討論內容之任何錯誤或遺漏，以及經由本平台張貼、發送電子郵件或傳送而衍生之任何損失或損害。本公司保留移除、審查及拒絕張貼於本平台之討論內容的權利而不作任何事前通知。</p><p>&nbsp;</p><p>7. 知識產權</p><p>本平台內所有知識產權均屬於本公司或已經由本公司取得許可使用。本公司有可能再宣傳或複製本平台，對於因本平台上提供的內容或再宣傳或複製的內容而引致的任何損失或損害賠償，本公司概不負責。在沒有本公司的允許下，該等內容的任何部分均不得上載、張貼、刊登、複製、傳送、再版、分發或作出衍生作品。</p><p>&nbsp;</p><p>你同意本平台可以任何方式、媒體及形式自由使用、披露、採用及修改你向本平台所提供之意見、意念、技術、建議、提議、批評及任何溝通及資料(&ldquo;回應&rdquo;)，而毋需向你承擔任何責任。你保證閣下已就為令本公司使用你的回應取得必要的所有轉讓、豁免、免除責任及同意。</p><p>&nbsp;</p><p>8. 彌償</p><p>由於你違反使用條款及/或使用本平台或閣下在本平台上的行為、你在本平台上或通過本平台發佈或傳送的內容或消息有關或因此而產生的任何責任、索償、訴訟、費用及支出，概由你作出彌償並使本公司不遭受任何損失。本公司保留權利由其自負費用獨自對應由你彌償的任何事項進行辯護和控制，但這不應免除你的彌償義務。</p><p>&nbsp;</p><p>9. 活動及福利兌換及享用</p><p>你只能在我們可能不時規定的指定地點申領福利及活動，而我們有權就該等福利及活動作出最終決定。 </p><p>&nbsp;</p><p>我們並非福利及活動之供應商，你應受可能不時適用於任何福利的條款及條件規限。任何有關該等福利及活動索賠或投訴，應直接向有關的供應商提出。我們不就有關事宜承擔任何責任/法律責任。 </p><p>&nbsp;</p><p>所有福利及活動的授予均視乎供應情況而定，額滿即止（如適用）。</p><p>&nbsp;</p><p>我們保留向你授予福利的權利及所有最終決定權，僅在我們確認你的帳戶有效且狀態良好時。 </p><p>&nbsp;</p><p>一旦我們接受你的任何兌換申請，你將不能更改或取消其兌換申請。</p><p>&nbsp;</p><p>你申領任何福利及活動時，我們及指定供應商有權要求你出示你的電子卡。如有需要，我們亦有權要求你出示其他身份證明文件，以核實身份。 </p><p>&nbsp;</p><p>10. 獎勵兌換</p><p>你透過此本平台申請兌換獎勵。我們可根據 (其中包括) 你在本平台的積分是否足夠以及獎勵的供應情況等來決定是否接受或拒絕此類申請。 </p><p>&nbsp;</p><p>我們並非獎勵之供應商，你應受可能不時適用於任何福利的條款及條件規限。任何有關該等獎勵索賠或投訴，應直接向有關的供應商提出。我們不就有關事宜承擔任何責任/法律責任。 </p><p>&nbsp;</p><p>我們保留向你授予獎勵的權利及所有最終決定權，僅在我們確認你的帳戶有效且狀態良好時。 </p><p>&nbsp;</p><p>你可以根據指定供應商不時適用的條款及條件兌換獎勵。</p><p>&nbsp;</p><p>在成功兌換獎勵後，我們可將相關的兌換憑證（包括但不限於二維碼、推廣碼、PDF 檔案或連結）存入你於本平台的帳戶。持有人有權憑該等憑證，按所列明的指定有效期及（如適用）指定地點兌換獎勵。 </p><p>&nbsp;</p><p>獎勵以先到先得方式提供，額滿即止。</p><p>&nbsp;</p><p>獎勵及已發出的兌換憑證（無論以二維碼、推廣碼、PDF 或連結形式發放）均不能兌換為現金或其他禮品。</p><p>&nbsp;</p><p>特定條款及條件可能適用於每項獎勵及所發出的兌換憑證。</p><p>&nbsp;</p><p>11. 使用條款修訂</p><p>本公司將不時修改使用條款而不會作另行通知。如在修訂條款後你繼續使用本網站，即代表你同意受此等修訂之約束。 </p><p>&nbsp;</p><p>12. 對服務的修改</p><p>本公司有權隨時未經通知修改或暫停或永久終止本平台或其中任何部分。你同意就本平台或其中任何部分的任何修改、暫停或終止，本公司毋須向你或任何第三者負責。 </p><p>&nbsp;</p><p>13. 免責聲明</p><p>本平台乃根據〝所見現狀〞及〝所能提供〞的基礎條件下提供，你因使用網站而導致的一切後果，概須自行承擔。本平台僅供你個人、非商業性質、與非工作有關有關使用，本公司不發表任何聲明或作出任何保證，無論是明示的或暗示的，包括但不限於任何不侵權、可商售性、準確或就某目的的適用性的保證。本公司不擔保或者承擔下列任何責任：</p><p>(i)&nbsp;&nbsp; 本平台提供的資訊是否準確、充足、及時或可靠，或是否除一般參考外還可用於任何目的； </p><p>(ii)&nbsp;&nbsp; 本平台提供的資訊是否無缺陷、錯誤、遺漏、病毒或可改變、刪除、增加或損壞閣下的軟件、資料或者設備的任何有害物； </p><p>(iii)&nbsp;&nbsp; 經互聯網發出的訊息不會被截、中斷或丟失； </p><p>(iv)&nbsp;&nbsp; 接通時，本平台可用或者不中斷；</p><p>(v)&nbsp;&nbsp; 本平台的缺點會被糾正；或</p><p>(vi)&nbsp;&nbsp; 本平台或提供平台的伺服器沒有病毒或其他有害成分；通過本平台傳送的訊息將能維持保密。在任何情況下，本公司對你或者任何其他人士因使用或不能使用該等資訊所發生的任何直接的、間接的、附帶引起的、特別的、懲罰性的或者間接性的損失(包括任何業務或盈利的損失)，不承擔任何責任。你在使用或者解釋該等資訊時，應只運用並依賴自己的技能和判斷。你有責任確保使用該等資訊須遵守所有適用的法律規定。</p><p>&nbsp;</p><p>14. 系統使用</p><p>本公司不保證你能在不受干擾、持續或安全的情況下進入本平台。部分或整個平台可能突然在任何時段內或因各種原因不能使用，其中包括系統失靈或中斷、互聯網停機或其他技術故障；本公司對此等原因並無控制權，亦概不負責。你同意自行承擔使用本平台的一切相關風險，亦不就你因任何原因無法使用本平台而引致的任何損害或損失，向本公司追究責任。本公司有權基於種種原因將部分或整個平台離線，其中包括系統維修或升級。</p><p>&nbsp;</p><p>15. 終止服務</p><p>本公司有完全酌情權在發出或不發出通知的情況下以任何理由決定終止或暫停你使用本平台全部或部分之服務，包括但不限於違反本平台的使用條款，或你於一定時間未有使用本平台之服務。本公司不會為你或任何第三者承擔因終止服務所涉及任何索償的責任。</p><p>&nbsp;</p><p>16. 登入帳號</p><p>由於本平台是本公司專屬的內部移動平台，所有登入本平台之帳號必須按本公司內部指引及授權下來提供用戶使用。 </p><p>&nbsp;</p><p>17. 條款的分割性</p><p>如果任何條款被具有司法管轄權區的法院認為不合法或無法強制執行，亦不會影響其餘條款的效力及可強制執行性。 </p><p>&nbsp;</p><p>18. 適用法律及司法管轄權</p><p>使用條款受香港特區政府之法律規限，對於任何與本平台相關的任何爭議，你同意接受香港法院的非專屬司法管轄權。 </p><p>&nbsp;</p><p>19. 語言</p><p>如使用條款中、英文兩個版本有任何抵觸或不相符之處，應以英文版本為準。</p><p>&nbsp;</p><p>20. 第三方權益</p><p>儘管有香港法例第623章&ldquo;合約（第三者權利）條例&rdquo;的規定，本使用條款是本公司與閣下的協議，僅為本公司與閣下之間的利益而作出，並非為向第三方產生或給予任何權利或聲稱賦予任何利益。 任何人士若非本條款及細則的一方，不可根據《合約（第三者權利）條例》（香港法例第623章）強制執行本條款及細則的任何條文。本公司與閣下於本使用條款之終止、撤銷、同意任何修訂、豁免、變更或解決方案的權利，均不受制於任何第三方的同意。</p><p>&nbsp;</p><p>21. 私隱政策及個人資料收集聲明</p><p>我們將根據香港法例《個人資料（私隱）條例》及我們的私隱政策聲明處理所有個人資料。請在此處參閱我們的私隱政策聲明：<a href='/tc/privacy-policy'>私隱政策聲明</a>。 </p><p>&nbsp;</p><p>在你申請會籍時，並收集你個人資料前，我們會提供相關的《個人資料收集聲明》。該聲明列明了收集的個人資料種類、目的、分享對象（如適用）及用作直接促銷時之用途，以獲取你的同意。 </p><p>&nbsp;</p><p><a href='https://www.ctflife.com.hk/tc/disclaimer/pics'>個人資料收集聲明</a></p><p>&nbsp;</p><p>22. 你的權利</p><p>你除了可以選擇不接收直接促銷，你亦有以下額外的權利，包括查詢我們有否保存你的任何個人資料、獲取我們所保存你的任何個人資料、要求更正任何不準確的個人資料及查詢我們對有關個人資料及其種類的政策和實施（偶爾）。 </p><p>&nbsp;</p><p>如果你有意對上述相關作出要求，請聯絡我們的個人資料私隱專員：</p><p>&nbsp;</p><p>周大福人壽保險有限公司</p><p>九龍觀塘海濱道123號綠景NEO大廈7樓</p><p>&nbsp;</p><p>聯絡人：</p><p>法律部</p><p>個人資料私隱專員</p><p>（標記為保密資料）</p><p>&nbsp;</p>",
    "checkbox_txt": "我同意接收來自的直接促銷，詳情已載於上文所述的《個人資料收集聲明》。",
    "checkbox_2_txt": "我同意接收來自周大福人壽保險有限公司的關聯公司和/或周大福人壽保險有限公司的營銷合作夥伴的直接促銷，詳情已載於上文所述的《個人資料收集聲明》。",
    "btn": "同意"
  },
  "privacy_policy": {
    "title": "私隱政策聲明",
    "home_desc": " <div style=\"font-family:Poppins;\"><br /><p><span style=\"font-weight:bold\">1.&nbsp;</span><span style=\"font-weight:bold\">承諾</span></p><p><span>周大福人壽保險有限公司（</span><span>&nbsp;&ldquo;</span><span>周大福人壽</span><span>&rdquo;</span><span>、</span><span>&ldquo;</span><span>本公司</span><span>&rdquo;</span><span>、</span><span>&ldquo;</span><span>我們</span><span>&rdquo;</span><span>、</span><span>&ldquo;</span><span>本公司的</span><span>&rdquo;</span><span>或</span><span>&ldquo;</span><span>我們的</span><span>&rdquo;</span><span>）瞭解及明白客戶、網站訪客及流動應用程式用戶對個人資料私隱的關注。周大福人壽承諾遵守中華人民共和國香港特別行政區（</span><span>&ldquo;</span><span>香港</span><span>&rdquo;</span><span>）《個人資料（私隱）條例》（第</span><span>486</span><span>章）（</span><span>&ldquo;</span><span>《私隱條例》</span><span>&rdquo;</span><span>）的規定。</span></p><p><span>本私隱政策聲明概述了周大福人壽對收集和使用您的個人資料的做法及您可作的相關選擇。本私隱政策聲明應與適用於周大福人壽提供的相關服務、網站及</span><span>/</span><span>或流動應用程式的條款及細則</span><span>(&ldquo;</span><span>條款及細則</span><span>&rdquo;)</span><span>結合一併解讀，但如果本私隱政策聲明與有關個人資料的條款及細則之間存在任何不一致，則以本私隱政策聲明為準。本私隱政策聲明亦應與適用於周大福人壽提供的相關服務、網站及</span><span>/</span><span>或流動應用程式的個人資料收集聲明（</span><span>&ldquo;</span><span>個人資料收集聲明</span><span>&rdquo;</span><span>）結合一併解讀，但如果本私隱政策聲明與有關個人資料的個人資料收集聲明之間存在任何不一致，則以個人資料收集聲明為準。</span></p><br /><p><a href=\"https://www.ctflife.com.hk/tc/disclaimer/pics\">個人資料收集聲明</a></p><br /><p><span style=\"font-weight:bold\">2.&nbsp;</span><span style=\"font-weight:bold\">資料搜集</span></p><p><span>您可能不時獲邀透過周大福人壽旗下相關的網站或流動應用程式或通過其他媒體，自願向周大福人壽提供您的個人資料作不同目的。如您未滿十八歲（</span><span>18</span><span>），在您向周大福人壽提供您的個人資料前，須先徵得您的父母或監護人的同意。</span></p><br /><p><span style=\"font-weight:bold\">3.&nbsp;</span><span style=\"font-weight:bold\">日誌文件</span></p><p><span>當您瀏覽周大福人壽的網站及</span><span>/</span><span>或使用周大福人壽的流動應用程式時，周大福人壽的伺服器將只收集與您的瀏覽</span><span>/</span><span>使用該網站，及</span><span>/</span><span>或使用該流動應用程式有關的數據，包括但不限於您的</span><span>IP&nbsp;</span><span>地址、域名、瀏覽器類型及訪問時間等（</span><span>&ldquo;</span><span>日誌文件</span><span>&rdquo;</span><span>），但不會收集您的個人資料。但是，如果您在我們的網站上註冊及登入您的帳戶，我們可能將您的日誌文件與我們從您收集的其他個人資料相結合，這些日誌文件將會被視為您的個人資料及按照本私隱政策聲明及個人資料收集聲明被使用。</span></p><br /><p><span style=\"font-weight:bold\">4. Cookies</span><span style=\"font-weight:bold\">的使用和其他跟蹤機制</span></p><p><span>當您瀏覽周大福人壽的網站及</span><span>/</span><span>或使用周大福人壽的流動應用程式時，</span><span>cookies</span><span>將被儲存在您的電腦、移動電話或其他設備中，僅作內部導航及編程之用。我們可能使用</span><span>cookies</span><span>和其他下文所述的跟蹤機制以跟蹤有關您使用周大福人壽網站及</span><span>/</span><span>或流動應用程式的信息（</span><span>&ldquo;</span><span>跟蹤數據</span><span>&rdquo;</span><span>）。我們可能將此跟蹤數據與我們向您收集的其他個人資料相結合，這些跟蹤數據將會被視為您的個人資料及按照本私隱政策聲明及個人資料收集聲明被使用。</span></p><p><span>Cookies</span><span>是我們通過您的網絡瀏覽器傳輸到您的電腦、移動電話或其他設備的字母數字標識符，以作保存記錄之用。有些</span><span>cookies</span><span>可讓我們為您安排更容易地瀏覽周大福人壽的網站及</span><span>/</span><span>或流動應用程式，而其他則應用於加快登入程序，或允許我們於周大福人壽的網站或周大福人壽的流動應用程式中存儲和跟蹤您的個人興趣和偏好。</span></p><p><span>我們還會委託第三方跟蹤和分析來自網站或流動應用程式的非可識別個人身份的數據。我們使用這些第三方收集的數據來幫助我們管理和改善周大福人壽網站或流動應用程式的質素，並分析其使用情況。此類資料與您的個人資料並無關連且為獨立的。這些第三方可將我們提供的關於您的非可識別個人身份的數據與他們收集的其他信息相結合。您可以通過編輯您的瀏覽器設置來禁用</span><span>cookies</span><span>，但一旦</span><span>cookies</span><span>被禁用，您可能無法繼續使用周大福人壽的網站及</span><span>/</span><span>或流動應用程式（在適用的情況下）的某些功能。</span></p><p><span>如您於社交媒體平臺上與周大福人壽互動（例如對周大福人壽的</span><span>Facebook</span><span>頁面「讚好」），周大福人壽將可與您互動，並透過此等平臺向您傳送訊息。周大福人壽將按照有關社交媒體平臺的規則與您互動，但我們不會為該平臺的營運商如何收集並處理您的個人資料而負上責任。我們不會為我們的社交媒體帳戶上的第三方貼文而負上責任。</span></p><br /><p><span style=\"font-weight:bold\">5.&nbsp;</span><span style=\"font-weight:bold\">所收集的資料種類</span></p><p><span>由於周大福人壽在業務上的不同需要，您可能須向周大福人壽提供您的個人資料類型包括您的姓名、性別、年齡（或年齡範圍）、出生日期、聯繫方式、電子郵件地址、郵寄</span><span>/</span><span>住宅</span><span>/</span><span>通訊地址、聯繫電話、會員編號、生物辨識資料、醫療及健康記錄、您的家庭、生活方式及社會環境資料、用戶名和密碼、日誌文件（見下文）、個人興趣及活動愛好、有關您使用應用程式及</span><span>/</span><span>或網站（視情況而定）及交易數據的跟蹤信息（包括您的特點及交易行為）（</span><span>&ldquo;</span><span>跟蹤數據</span><span>&rdquo;</span><span>）、社交媒體帳戶信息等相關資料，以及通過 Apple Health 或 Google Health Connect 收集的每日步數數據。</span></p><p><span>有關所收集的個人資料亦將陳列於相關的個人資料收集聲明之內並於收集個人資料時或之前向您提供。</span></p><br /><p><span style=\"font-weight:bold\">6.&nbsp;</span><span style=\"font-weight:bold\">所收集個人資料的目的及使用</span></p><p><span>周大福人壽會將您的個人資料用於收集資料時或之前所提供的相關個人資料收集聲明中所陳列的具體用途。這包括按陳列於個人資料收集聲明之內的目的分享您的個人資料予個人資料收集聲明中所陳列的第三方及使他們能使用您的個人資料。</span><span><br>&nbsp;<br></span><strong><u><span>企業健康計劃管理</span></u></strong>。為管理周大福人壽保險公司的企業健康計劃及員工步數挑戰，收集及使用員工的每日步數數據以計算獎勵積分。<br><br><strong><u><span>位置資料</span></u></strong><span>。我們可能會收集您的大概或精確位置資料。收集的方法取決於您如何使用我們的「</span><span>Adventure Hunt</span><span>功能」以及您的裝置設定進行互動。當應用程式未在使用時，我們可能會從您的裝置中收集您的精確地理位置（</span><span>GPS</span><span>）信息，前提是您在裝置上授予了權限。您可以在手機設備的系統中停用位置權限，以防止我們收集您的位置資訊；但在這種情況下，您可能無法使用我們提供的功能，並且您可能無法從相關服務中獲得預期的結果。</span></p><br /><p><span style=\"font-weight:bold\">7.&nbsp;</span><span style=\"font-weight:bold\">資料準確性</span></p><p><span>您可能須向周大福人壽提供您的某些個人資料以享用特定服務。若您未能按有關要求提供準確或更新相關個人資料，該等服務的提供或有可能受到影響。</span></p><br /><p><span style=\"font-weight:bold\">8.&nbsp;</span><span style=\"font-weight:bold\">資料保留</span></p><p><span>周大福人壽保留您的個人資料的時限將不超過實現目的所需或所將需要的時間。若您是周大福人壽有關服務的用戶，您提供的個人資料將被保留至您的服務期限或服務終止後的一段合理時間，以作核實及審計之用。上述情況均受任何法律、法令、法規或會計要求所約束。就8alance流動應用程式而言，用戶帳戶及相關個人資料是基於與周大福人壽保險公司的僱傭關係而建立，並一般會在僱傭關係終止後予以刪除，惟須受適用的法律、監管、審計及營運要求所規限。如要求刪除帳戶及相關個人資料，可電郵至<a href=\"mailto:8alance&#64;ctflife.com.hk\"><span style=\"font-weight:bold\">8alance&#64;ctflife.com.hk</span></a>提交申請。</span></p><br /><p><span style=\"font-weight:bold\">9.&nbsp;</span><span style=\"font-weight:bold\">第三方商戶</span></p><p><span>周大福人壽可能在周大福人壽的網站及</span><span>/</span><span>或流動應用程式上有由第三方經營的網上商店或服務及</span><span>/</span><span>或商品提供。若您為使用、訂購或接受任何第三方商戶的服務及</span><span>/</span><span>或商品而提供您的個人資料予第三方商戶，請注意，該等個人資料將不受周大福人壽的控制，並因此超出周大福人壽所提供的保護範圍。</span></p><br /><p><span style=\"font-weight:bold\">10.&nbsp;</span><span style=\"font-weight:bold\">第三方網站及</span><span style=\"font-weight:bold\">/</span><span style=\"font-weight:bold\">或流動應用程式</span></p><p><span>周大福人壽的網站及</span><span>/</span><span>或流動應用程式或將不時包含其他第三方網站及</span><span>/</span><span>或流動應用程式的連結。這些其他第三方網站及</span><span>/</span><span>或流動應用程式獨立於周大福人壽的網站或流動應用程式。周大福人壽無權控制或管理這些其他網站、這些流動應用程式的內容或其私隱政策或其對法律的遵守。您須充分注意提供這些連結並不構成周大福人壽對這些連結的認可、批准或與該連結有任何形式上的關聯。周大福人壽對您向其他網站及</span><span>/</span><span>或流動應用程式提供的個人資料（如有）無控制權。本私隱政策聲明僅適用於周大福人壽的網站及</span><span>/</span><span>或流動應用程式。您應閱讀其他網站或流動應用程式各自相關的私隱政策。</span></p><br /><p><span style=\"font-weight:bold\">11.&nbsp;</span><span style=\"font-weight:bold\">服務供應商</span></p><p><span>就於個人資料收集聲明中和上述第</span><span>6</span><span>段陳列的相關目的，周大福人壽可能將您的個人資料提供給向周大福人壽提供服務的個人或公司（無論香港境內或境外）（</span><span>&quot;</span><span>周大福人壽的服務供應商</span><span>&quot;</span><span>）。在此情況下，周大福人壽的服務供應商須在使用您的個人資料時，遵守其與周大福人壽簽訂的協議以及本私隱政策聲明和個人資料收集聲明的規定。</span></p><br /><p><span style=\"font-weight:bold\">12.&nbsp;</span><span style=\"font-weight:bold\">資料的保安</span></p><p><span>我們及按本私隱政策聲明和個人資料收集聲明共享您的個人資料之第三方會將您的個人資料的實體記錄保存在設有接觸限制的安全地方（無論香港境內或境外）。您的個人資料的電子記錄將保存在周大福人壽及</span><span>/</span><span>或作為我們數據處理商的相關周大福人壽服務供應商的伺服器中（無論在香港境內或境外），該伺服器也將被放置在安全的地方及受足夠的資料保安措施所保護</span><span>&nbsp;(</span><span>例如：當有需要於互聯網上傳送敏感資料時，會將之加密</span><span>)</span><span>，我們或將通過合同方式或盡本公司的合理努力，確保按本私隱政策聲明和個人資料收集聲明共享您的個人資料之第三方會提供同等程度的保護（無論香港境內或境外）。只有獲得周大福人壽授權的員工</span><span>(</span><span>曾接受處理個人資料訓練及有保密責任之人士</span><span>)</span><span>才可於</span><span>&ldquo;</span><span>有需要知道</span><span>&rdquo;</span><span>及</span><span>&ldquo;</span><span>有需要使用</span><span>&rdquo;</span><span>時接觸該等記錄及伺服器，或我們將通過合同方式或盡本公司的合理努力確保按本私隱政策聲明和個人資料收集聲明共享您的個人資料之第三方會提供同等程度的保護（無論香港境內或境外）。</span></p><p><span>我們按我們的個人資料收集聲明可能會將您的個人資料存儲在香港境內或境外的實際地點及</span><span>/</span><span>或伺服器中，並且</span><span>/</span><span>或者與香港境內或境外的第三方共享。但是，無論你的個人資料存儲在任何國家</span><span>/</span><span>地區，我們將採取一切合理措施確保您的個人資料得以安全存儲和處理，及我們通過合同方式或盡本公司的合理努力確保任何第三方會提供同等程度的保護。我們將根據個人資料收集聲明和適用法律對您的個人資料進行跨境傳輸，以保護您的個人資料。</span></p><p><span>任何透過互聯網或任何其他公共網絡上傳輸的數據是不可能保証完全安全的，而您與我們通信亦非完全可確保隱私。周大福人壽鼓勵您保護您的密碼以防止未經授權的讀取，亦建議您在使用註冊帳戶後登出您的帳戶，尤其在使用共用電腦的情況下。</span></p><br /><p><span style=\"font-weight:bold\">13.&nbsp;</span><span style=\"font-weight:bold\">豁免</span></p><p><span>周大福人壽將根據法律要求或應任何政府部門、監管機關、執法機構或具有司法管轄權的法院的要求披露您的個人資料。周大福人壽不會承擔以此方式披露您的個人資料的任何責任。</span></p><br /><p><span style=\"font-weight:bold\">14.&nbsp;</span><span style=\"font-weight:bold\">用於法律訴訟等</span></p><p><span>當周大福人壽有必要使用您的個人資料以採取法律行動促使您償還您對周大福人壽的欠款，您同意周大福人壽可將您提供的個人資料用於確認您的身份及對您採取法律行動。</span></p><br /><p><span style=\"font-weight:bold\">15.&nbsp;</span><span style=\"font-weight:bold\">查閱、改正資料及撤銷同意</span></p><p><span>通過致函周大福人壽的個人資料私隱主任，您有權：</span></p><ol start=\"1\" type=\"a\"><li style=\"color:#212529;\"><span>檢查周大福人壽是否持有您的任何個人資料；</span></li></ol><ol start=\"2\" type=\"a\"><li style=\"color:#212529;\"><span>查閱周大福人壽所持有的您的個人資料（如有）</span></li></ol><ol start=\"3\" type=\"a\"><li style=\"color:#212529;\"><span>要求周大福人壽改正有關您的不準確的個人資料記錄（如有）； </span></li></ol><ol start=\"4\" type=\"a\"><li style=\"color:#212529;\"><span>確定我們關於個人資料和我們持有的個人資料類型的不時生效的政策和做法；</span></li></ol><ol start=\"5\" type=\"a\"><li style=\"color:#212529;\"><span>撤銷有關使用個人資料作直接促銷之同意（見下文）。</span></li></ol><p><span>上述要求將會根據《私隱條例》之規定迅速地處理，周大福人壽可能就處理您的查閱個人資料的要求收取合理費用。8alance 流動應用程式用戶如欲刪除其帳戶及相關個人資料，可電郵至<a href=\"mailto:8alance&#64;ctflife.com.hk\"><span style=\"font-weight:bold\">8alance&#64;ctflife.com.hk</span></a>提出要求。</span></p><br /><p><span style=\"font-weight:bold\">16.&nbsp;</span><span style=\"font-weight:bold\">直接促銷</span></p><p><span>周大福人壽不可於沒有您的同意下使用或提供給第三方（無論是集團內部及</span><span>/</span><span>或外部方）您的個人資料作直接促銷目的。在您同意下，我們可能會根據收集您的個人資料時或之前提供給您的個人資料收集聲明使用或提供給第三方（無論是集團內部及</span><span>/</span><span>或外部方）您的個人資料作直接促銷目的。您可隨時透過致函周大福人壽的個人資料私隱主任，地址為九龍觀塘海濱道123號綠景NEO大廈7樓</span><span>，或電郵至</span><span><a href=\"mailto:8alance&#64;ctflife.com.hk\"><span style=\"font-weight:bold\">8alance&#64;ctflife.com.hk</span></a></span><span>，撤銷您的同意。</span></p><br /><p><span style=\"font-weight:bold\">17.&nbsp;</span><span style=\"font-weight:bold\">私隱政策聲明的變更</span></p><p><span>本私隱政策聲明將不時更新、修改或修訂。任何更新、修改或修訂將於公佈於周大福人壽的網站及</span><span>/</span><span>或流動應用程式時即時生效。當法律上要求時，我們將通知及</span><span>/</span><span>或徵得您對某些重大的更新、修改或修訂的同意。如果您不接受更新、修改或修訂及</span><span>/</span><span>或提供您的同意，那麽我們可能無法向您提供商品或服務。我們建議您定期查看周大福人壽的網站及</span><span>/</span><span>或流動應用程式以獲取本私隱政策聲明的更新版本。</span></p><br /><p><span style=\"font-weight:bold\">18.&nbsp;</span><span style=\"font-weight:bold\">控制權的變動</span></p><p><span>如果本公司或本公司的業務或本公司的關聯公司或關聯公司的業務涉及任何實際或擬議的業務轉讓、股份轉讓、重組、合併、併購、出售、轉讓或購買，周大福人壽可能有需要按照個人資料收集聲明將您的個人資料轉移至該些實體。您將獲通知有關資料轉移，並可選擇撤銷使用個人資料之同意。</span></p><br /><p><span style=\"font-weight:bold\">19.&nbsp;</span><span style=\"font-weight:bold\">查詢</span></p><p><span>若您有任何疑問，或欲查閱或改正相關的周大福人壽旗下公司存儲您的個人資料或撤銷使用個人資料作直接促銷之同意，請與周大福人壽的個人資料私隱主任聯絡：</span></p><p><span>周大福人壽保險有限公司</span><span><br>&nbsp;</span><span>九龍觀塘海濱道123號綠景NEO大廈7樓</span></p><p><span>聯絡人：</span><span><br>&nbsp;</span><span>個人資料私隱專員</span><span><br>&nbsp;</span><span>（標記為保密資料）</span></p><p><span>或電郵至</span><span><a href=\"mailto:8alance&#64;ctflife.com.hk\"><span style=\"font-weight:bold\">8alance&#64;ctflife.com.hk</span></a></span><span>。</span></p><br /><p><span style=\"font-weight:bold\">20.&nbsp;</span><span style=\"font-weight:bold\">不一致或衝突</span></p><p><span>如本私隱政策聲明的中英文版本有任何不一致或衝突，須以英文版本為準。</span></p><br /><p><span style=\"font-weight:bold\">21.&nbsp;</span><span style=\"font-weight:bold\">中華人民共和國附錄</span></p><p><span>如果您是：</span></p><p><span>(i)&nbsp;</span><span>位於中國內地的個人，於中國內地訪問我們相關網站或使用我們相關流動應用程式或從中國內地通過手機或任何其他方式使用我們產品及</span><span>/</span><span>或服務；及</span><span>/</span><span>或</span></p><p><span>(ii)&nbsp;</span><span>持有中國內地護照及</span><span>/</span><span>或居民身份證的個人，到訪我們在香港的實體場所或在香港通過手機或任何其他方式使用我們產品及</span><span>/</span><span>或服務，</span></p><p><span>除</span><span>&nbsp;(i)</span><span>周大福人壽私隱政策</span><span>;&nbsp;</span><span>和</span><span>(ii)</span><span>本聲明以及中國內地適用的數據保護法律和法規外，我們將根據</span><span>&nbsp;&ldquo;</span><span>中華人民共和國附錄</span><span>&rdquo;</span><span>處理您的個人資料。</span></p><p><span>&ldquo;</span><span>中國內地</span><span>&rdquo;</span><span>是指中華人民共和國除香港特別行政區（</span><span>&ldquo;</span><span>香港</span><span>&rdquo;</span><span>）、澳門特別行政區和臺灣以外的地區。</span></p><p style=\"font-size:15px;\"><span>請瀏覽</span><a href=\"https://www.ctflife.com.hk/\"><span style=\"font-weight:bold\">https://www.ctflife.com.hk</span></a><span>參閱詳細附錄。</span></p></div>"
  },
  "step_count": {
    "app": {
      "apple_health": "Apple Health",
      "health_connect": "Health Connect",
      "garmin": "Garmin"
    },
    "walking_board": {
      "connect": "連接裝置",
      "have_issue": "發生問題！"
    },
    "sync_step_board": {
      "start_sync": "手動同步",
      "relogin_garmin": "重新連接"
    },
    "page": {
      "connect_device": {
        "title": "連接健康數據",
        "sub_title": "",
        "desc": "連接裝置，以記錄步行數據來完成健康活動並換取獎賞。",
        "android_desc_1": {
          "title": "登入 Health Connect",
          "content": "登入 Health Connect 後，即可同步步數數據，參加由周大福人壽保險有限公司舉辦的 8alance 企業健康計劃（步數挑戰及健康獎賞）。您的步數數據僅於取得您同意後用作管理此計劃，不會用於廣告、僱傭、保險或其他用途。"
        },
        "android_desc_2": "在使用從 Google API 接收的信息以及將其傳輸至任何其他應用程序時，8alance 將遵守 <a href='https://developers.google.com/terms/api-services-user-data-policy' target='_blank'>Google API Services User Data Policy</a>，包括有限使用的要求。",
        "android_desc_3": "📱 若您使用的是 Android 13 或更早版本<br />我們建議改用 Garmin，以獲得更穩定的使用體驗。<br />👉 若您仍希望使用 Health Connect，請先到 Play 商店安裝該應用程式。",
        "btn": {
          "ios": {
            "apple_health": "下一步",
            "garmin": "登入 Garmin"
          },
          "android": {
            "health_connect": "登入 Health Connect",
            "garmin": "登入 Garmin"
          }
        }
      },
      "connect_intro": {
        "title": "踏出健康一步",
        "desc": "想不費分毫就得到身心健康？試試每日抽出點時間走走看吧！<br/><br/>專家建議每日至少以步行10,000步為佳，然而繁重的生活可能讓你無法輕易達成目標。沒關係！10,000步走不完，可先試試完成8,000步挑戰，然後才再嘗試挑戰完成10,000步以至12,500步！要記住，起步其實比完達標更重要！<br/><br/>立即連接裝置，展開你的健康第一步吧！",
        "btn": {
          "disconnect": "開始起行！"
        }
      },
      "change_device": {
        "title": "連接健康數據App",
        "sub_title": "",
        "desc": "你即將取消所選取的健康App的連接，不過你亦將無法全面享用8alance的功能。",
        "btn": {
          "disconnect": "還要繼續嗎？"
        }
      },
      "device_connected": {
        "title": "立即起行！",
        "desc": "已連接健康數據，現在就立刻起步，邁向健康旅程。",
        "btn": {
          "back": "返回主頁"
        }
      },
      "garmin_connected": {
        "title": "🟢 <strong>Garmin 已成功連接！</strong>",
        "content": "✅ <strong>下一步：</strong><br />請<strong>返回 8alance App </strong>繼續操作。<br />您可以關閉此頁面，或手動切換回 App。",
        "desc": "📌  <strong>提醒您：</strong><br />如果您回到 App 後仍看到「同步您的健康資料」畫面 ;<br />請不用擔心，Garmin 已經成功連接。"
      },
      "device_disconnected": {
        "title": "隨時歡迎你回來",
        "desc": "等你下次準備好時，歡迎你再與我們分享你的健康數據！",
        "desc_android_1": "想重新連結你的資料嗎？ 📱🔄🧘",
        "desc_android_2": "👉請重新開啟應用程式，並前往 Wellness 頁面進行連結。",
        "btn": {
          "back": "返回主頁"
        }
      },
      "intro": {
        "title": "為健康行多步",
        "desc": "每日多走一步，能讓你在不動用任何器材之下，帶來數之不盡的好處。<br/><br/>專家建議每日至少步行10,000步，以助你維持健康體重、促進心臟和肺部健康、強化肌肉和骨骼，以及減低長期疾病和焦慮的風險。",
        "tnc": "條款及細則",
        "btn": {
          "disconnect": "取消連結"
        }
      }
    },
    "popup": {
      "deny_permission": {
        "title": "解鎖健康旅程",
        "desc": "你可前往「設定」>「健康」>「資料存取及裝置」>「8alance」，允許8alance讀取資料，以開始步行任務！",
        "btn": "沒問題！"
      },
      "disconnect_device": {
        "ios": {
          "title": "取消裝置連結",
          "desc": "你確定要錯過享用8alance的全面功能和獎賞嗎？",
          "btn": {
            "no": "保留連接",
            "yes": "取消連結"
          }
        },
        "android": {
          "title": "取消裝置連結",
          "desc": "你確定要錯過享用8alance的全面功能和獎賞嗎？",
          "btn": {
            "no": "保留連接",
            "yes": "取消連結"
          }
        }
      },
      "disconnect_reminder": {
        "ios": {
          "title": "取消裝置連結",
          "desc": "如需取消Apple Health的連結，請先卸載並重新安裝8alance App。",
          "btn": {
            "ok": "知道了"
          }
        }
      },
      "detected_no_permission": {
        "title": "請允許資料存取許可！",
        "desc": "你可前往「設定」>「健康」>「資料存取及裝置」>「8alance」，並重新打開「8alance」，以開始步行任務。",
        "btn": "沒問題！"
      },
      "detected_change_device": {
        "title": "需要更換裝置？",
        "desc": "更換裝置時，App僅會保存新裝置的步行紀錄。",
        "btn": {
          "no": "使用目前的裝置",
          "yes": "立即更換"
        }
      },
      "detected_being_connected": {
        "title": "噢！裝置已連接其他帳戶",
        "desc": "請聯繫8alance&#64;en-verity.com，以取得協助。",
        "btn": "知道了"
      },
      "refuse_to_give_permission": {
        "ios": {
          "title": "未能取得資料存取許可?",
          "desc": "你可前往「設定」>「健康」>「資料存取及裝置」>「8alance」，允許8alance讀取資料，以開始步行任務！",
          "btn": "沒問題！"
        },
        "android": {
          "title": "未能取得資料存取許可",
          "desc": "再試試連結裝置，以開始步行任務！",
          "btn": "沒問題！"
        }
      },
      "confirm_sync_step_count": {
        "title": "手動同步步數紀錄",
        "desc": "8alance將從你已連接的健康裝置取得過去7天最新的步數紀錄，並按此發還未發放的積分。",
        "btn": "立即同步",
        "lastSync": "上次同步時間 :"
      },
      "sync_step_count_with_point": {
        "title": "同步完成！",
        "desc": "你已獲得 <img src='/images/common/new8alancecoin.svg' alt='' class='img--coin'/> {point} 積分！繼續努力！",
        "btn": "返回主頁"
      },
      "sync_step_count_with_no_point": {
        "title": "同步完成！",
        "desc": "今次同步未能獲取積分，多出去走走吧！",
        "btn": "返回主頁"
      },
      "tnc": {
        "title": "步行目標規則：",
        "desc": "<b>1. 每日重設：</b><br/>步數目標將每天於香港時間00:00重設。<br/><br/> <b>2. 追蹤限制：</b><br/>你可將最多7天的步數數據來賺取積分。<br/><br/> <b>3. 數據完整性：</b><br/>我們只接受準確的步行數據，請確保你的穿戴式裝置設定正確。<br/><br/> <b>4. 第三方裝置：</b><br/>來自第三方裝置的資料或無法完全或準確地反映在Apple Health或Health Connect上， 8alance只會收集以上應用程式中的數據來計算你的步數。<br/><br/> <b>5. 同步提醒：</b><br/>請記得定期同步數據，我們並不會對未經同步的數據負責。"
      },
      "garmin_fail_case": {
        "title": "未能取得資料存取許可",
        "content": "再試試連結裝置，以開始步行任務！",
        "btnText": "知道了"
      }
    }
  }
}
